import { BaseApi, type ItemResponse, type RequestHeaders, type RequestParams } from '@bv/api/base';

interface RechargeResponse {
  url: string;
  expiry_time: string;
}

interface BalanceResponse {
  balance: number;
  invalid_balance?: boolean;
}

class WalletAPI extends BaseApi {
  constructor(public endpoint = '/billing/customers') {
    super(endpoint);
  }

  public async create(
    data: Partial<{ payment_amount: number }> | FormData,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<RechargeResponse> {
    return this.request<RechargeResponse, ItemResponse<RechargeResponse>>({
      method: 'post',
      url: '/charge-wallet',
      data,
      params,
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  public async show({
    params,
    headers,
  }: {
    params?: RequestParams;
    headers?: RequestHeaders;
  } = {}): Promise<BalanceResponse> {
    return this.request<BalanceResponse, ItemResponse<BalanceResponse>>({
      method: 'get',
      url: 'get-wallet-balance',
      params,
      headers,
    }).then((response) => {
      return response.data;
    });
  }
}

export const walletApi = new WalletAPI();
